import React, { useState } from 'react';
import '../styles/CallBack.css';
import { FaAngleRight } from 'react-icons/fa';


const Faq = () =>{
	
	const [faqs] = useState([
		{
			id: 1,
			title: 'What is AtEase Insurance?',
			text: 'Duis mattis sit amet enim in cursus. Cras a arcu porttitor, feugiat massa sed, ullamcorper dui. Sed fermentum laoreet odio vel rhoncus'
		},{
			id: 2,
			title: 'How does your company determine my premium?',
			text: 'Duis mattis sit amet enim in cursus. Cras a arcu porttitor, feugiat massa sed, ullamcorper dui. Sed fermentum laoreet odio vel rhoncus'
		},{
			id: 3,
			title: 'Why do I need to disclose my income on the application?',
			text: 'Duis mattis sit amet enim in cursus. Cras a arcu porttitor, feugiat massa sed, ullamcorper dui. Sed fermentum laoreet odio vel rhoncus'
		},{
			id: 4,
			title: 'Who is a beneficiary?',
			text: 'Duis mattis sit amet enim in cursus. Cras a arcu porttitor, feugiat massa sed, ullamcorper dui. Sed fermentum laoreet odio vel rhoncus'
		},{
			id: 5,
			title: 'Can I buy more than one policy?',
			text: 'Duis mattis sit amet enim in cursus. Cras a arcu porttitor, feugiat massa sed, ullamcorper dui. Sed fermentum laoreet odio vel rhoncus'
		}
])
	return (
	  <>
		<div className="faq-content">
									<h2 className="h2-title">Frequently Asked Questions</h2>
				<div className="accordion faq-box" id="accordionExample">
					{faqs.map(faq => (
										<div className="accordion-item faq-bg shadow">
											 <h3 className="accordion-header h3-title" id={`heading${faq.id}`}>
								<button className="accordion-button faq-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${faq.id}`} aria-expanded="true" aria-controls={`collapse${faq.id}`}>
								{faq.title}<span className="icon"><FaAngleRight /></span>
								</button>
											</h3>
											 <div id={`collapse${faq.id}`} className="accordion-collapse collapse" aria-labelledby={`heading${faq.id}`} data-bs-parent="#accordionExample">
								<div className="accordion-body">
									<p className="faq__text">{faq.text}</p>
								</div>
							  </div>

						</div>
						))}
				</div>
		

		</div>
	  </>
)
	}

export default Faq;
